module.exports = __webpack_public_path__ + "img/header-bg.9cc13ec5.png";